import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import TasksBasicInfoComponent from './tasks-basic-info.component';

export const TasksComponent = ({
  handleInnerFormChange, selectedTasks, sourceType, relatedToTypes, back, taskStatus, handleFormSubmit,
  contacts, leads, opportunities, campaign, accounts
}: any) => {
  
  const tabItems = [
    {
      id: 1,
      title: 'Task Details',
      component: <TasksBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedTasks={selectedTasks}
        taskStatus={taskStatus}
        relatedToTypes={relatedToTypes}
        sourceType={sourceType}
        contacts={contacts}
        leads={leads}
        opportunities={opportunities}
        campaign={campaign}
        accounts={accounts}
      />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}

export default TasksComponent;
